import { v4 as uuidv4 } from "uuid";

function chillHop() {
  return [
    {
      name: "Collages",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/25a182a6a21588b8f7ad5605ba1118a8ea61bdc2.jpg",
      artist: "Sleepy Fish",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=7985",
      color: ["#8FD0E2", "#2D909D"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "The Shore and You",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/25a182a6a21588b8f7ad5605ba1118a8ea61bdc2.jpg",
      artist: "Sleepy Fish",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=7980",
      color: ["#8FD0E2", "#2D909D"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Fireplace",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/25a182a6a21588b8f7ad5605ba1118a8ea61bdc2.jpg",
      artist: "Sleepy Fish",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=7976",
      color: ["#8FD0E2", "#2D909D"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Velocities",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/25a182a6a21588b8f7ad5605ba1118a8ea61bdc2.jpg",
      artist: "Sleepy Fish",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=7988",
      color: ["#8FD0E2", "#2D909D"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Beaver Creek",
      cover: "https://i.scdn.co/image/ab67616d0000b27392ea33b2d11348d692352a33",
      artist: "Aso, Middle School, Aviino",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10076",
      color: ["#47E5D6", "#FBBC77"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Under the city of stars",
      cover: "https://i.scdn.co/image/ab67616d0000b27392ea33b2d11348d692352a33",
      artist: "Aso, Middle School, Aviino",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10074",
      color: ["#47E5D6", "#FBBC77"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Firefly Field",
      cover: "https://i.scdn.co/image/ab67616d0000b27392ea33b2d11348d692352a33",
      artist: "Aso, Middle School, Aviino",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10078",
      color: ["#47E5D6", "#FBBC77"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Want to",
      cover: "https://i.scdn.co/image/ab67616d0000b273a188604b1a23092a35daa9cb",
      artist: "Birocratic, Søren Søstrom",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=45153",
      color: ["#7BE7FF", "#9988E4"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Daylight",
      cover: "https://i.scdn.co/image/ab67616d0000b273797b1f1ca8576715f8708f65",
      artist: "Aiguille",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9272",
      color: ["#FACCBB", "#81B5D2"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Nightfall",
      cover: "https://i.scdn.co/image/ab67616d0000b273797b1f1ca8576715f8708f65",
      artist: "Aiguille",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9148",
      color: ["#FACCBB", "#81B5D2"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Calm",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/06/d9d8ae69141cb7838e3c53bbf393c6218285e384.jpg",
      artist: "ØDYSSEE, Florent Garcia",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9285",
      color: ["#DCBAB2", "#707ABC"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Time to Chill",
      cover:
        "https://chillhop.com/wp-content/uploads/2022/09/1a58532ef45339e1bd1a3324635e3cf133f9940b.jpg",
      artist: "C Y G N",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=45152",
      color: ["#FDFFF5", "#5E87C6"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Lagoons",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/06/49f6e32ca521fbad46a1b281e3893cf6254bf11d.jpg",
      artist: "Strehlow, Chris Mazuera",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=8266",
      color: ["#C65045", "#D6AA9F"],
      id: uuidv4(),
      active: false,
    },
  ];
}

export default chillHop;
